// Possible values for the contact detail country on a given company
export const companyCountries = {
  USA: 'usa',
  CANADA: 'can',
};
